var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.Status == 0 ? 'required' : ''),
      expression: "Status == 0 ? 'required' : '' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }],
    ref: "input",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingID')
    },
    staticStyle: {},
    attrs: {
      "placeholder": "Enter ShippingId / AWB",
      "id": "ShippingID",
      "type": "text",
      "name": "ShippingID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingID')),
      expression: "errors.has('form-1.ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter ShippingID")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShippingID')),
      expression: "errors.has('ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShippingID')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getShipmentdetailsbyshippingid
    }
  }, [_vm._v("Show Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])], 1)])]), _vm._v(" "), (_vm.checkCount == 2) ? _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "10px",
      "color": "red"
    },
    model: {
      value: (_vm.ReturnMessage),
      callback: function($$v) {
        _vm.ReturnMessage = $$v
      },
      expression: "ReturnMessage"
    }
  }, [_vm._v("Error - " + _vm._s(_vm.ReturnMessage))])]) : _vm._e(), _vm._v(" "), (_vm.checkCount == 1) ? _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_c('legend', [_vm._v("Shipping ID : "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.shipmentData.ShippingID) + " ")])]), _vm._v(" "), _c('legend', [_vm._v("Service Type : "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("  " + _vm._s(_vm.shipmentData.ServiceType))])]), _vm._v(" "), _c('legend', [_vm._v("Net Payment : "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.shipmentData.CollectibleAmount) + " ")])])])]), _vm._v(" "), _c('td', [_c('b', [_c('legend', [_vm._v("Order Type : "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.shipmentData.OrderType) + " ")])]), _vm._v(" "), _c('legend', [_vm._v("Status : "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.shipmentData.Status) + " ")])]), _vm._v(" "), _c('legend', [_vm._v("Octro MRP : "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.shipmentData.DeclaredValue) + " ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.checkCount == 1) ? _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "animated fadeIn",
    staticStyle: {
      "margin-left": "-20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ChangeIN),
      expression: "ChangeIN"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ChangeIN')
    },
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "name": "ChangeIN",
      "id": "ChangeIN"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ChangeIN = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setChangeIN]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.ChangeINList), function(ChangeIN_obj) {
    return _c('option', {
      domProps: {
        "value": ChangeIN_obj
      }
    }, [_vm._v(_vm._s(ChangeIN_obj))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ChangeIN')),
      expression: "errors.has('ChangeIN')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select ChangeIN")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.commentFlag == 1) ? _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "animated fadeIn",
    staticStyle: {
      "margin-left": "-20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('legend', [_vm._v("Change IN : " + _vm._s(_vm.ChangeIN))])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateShipmentDetails('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.change == 2) ? _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NetPayment),
      expression: "NetPayment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^(\d*\.)?\d+$/
      }),
      expression: "{ regex: /^(\\d*\\.)?\\d+$/ }"
    }],
    ref: "input",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('NetPayment')
    },
    staticStyle: {},
    attrs: {
      "placeholder": "Enter Net Payment",
      "id": "NetPayment",
      "type": "text",
      "name": "NetPayment"
    },
    domProps: {
      "value": (_vm.NetPayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.NetPayment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('NetPayment')),
      expression: "errors.has('NetPayment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('NetPayment')))])], 1) : _vm._e(), _vm._v(" "), (_vm.change == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OrderType),
      expression: "OrderType"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('OrderType')
    },
    attrs: {
      "name": "OrderType",
      "id": "OrderType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OrderType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.OrderTypeList), function(OrderType_obj) {
    return _c('option', {
      domProps: {
        "value": OrderType_obj
      }
    }, [_vm._v(_vm._s(OrderType_obj))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('OrderType')),
      expression: "errors.has('OrderType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select OrderType")])]) : _vm._e(), _vm._v(" "), (_vm.change == 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ServiceType),
      expression: "ServiceType"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ServiceType')
    },
    attrs: {
      "name": "ServiceType",
      "id": "ServiceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ServiceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.ServiceTypeList), function(ServiceType_obj) {
    return _c('option', {
      attrs: {
        "required": ""
      },
      domProps: {
        "value": ServiceType_obj
      }
    }, [_vm._v(_vm._s(ServiceType_obj))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ServiceType')),
      expression: "errors.has('ServiceType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select ServiceType")])]) : _vm._e(), _vm._v(" "), (_vm.commentFlag == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(6), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    staticClass: "col-md-15",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    staticStyle: {
      "width": "100%",
      "margin-left": "15px"
    },
    attrs: {
      "rows": "2",
      "placeholder": "Enter comments here..",
      "name": "comments",
      "id": "comments",
      "maxlength": _vm.max,
      "required": ""
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue",
      "margin-left": "15px"
    }
  }, [_vm._v(" Maximum length 500/" + _vm._s((_vm.max - _vm.comments.length)) + " Characters. ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter Comments.")])], 1) : _vm._e(), _vm._v(" "), (_vm.commentFlag == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Update")])])], 1) : _vm._e()])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('legend', [_vm._v("Change Shipment Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Shipping ID :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "25px",
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Shipment Details Change In:"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Net Payment :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Order Type: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Type: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Comments: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59507713","hasScoped":true}!./src/views/components/ChangeShipmentDetails/ChangeShipmentDetails/ChangeShipmentDetails.component.html
// module id = 1266
// module chunks = 1